module.exports = __webpack_public_path__ + "img/next.49f0848c.svg";